import Swal from 'sweetalert2';

// A slow (polled) export finishes long after the click, so browsers block window.open.
// Fall back to a button the user can click, which counts as a fresh user gesture.
export const openExport = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
        Swal.fire({
            title: 'Your export is ready',
            confirmButtonText: 'Open',
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) window.open(url, '_blank');
        });
    }
};
